import { ChangeDetectorRef, Component, Inject } from '@angular/core';
import {
  MatDialog,
  MatDialogRef,
  MAT_DIALOG_DATA,
} from '@angular/material/dialog';
import { FormBuilder, FormGroup } from '@angular/forms';
import { CustomerService } from '../crud-service';
import { ToastService } from 'src/app/shared/services/toast/toast.service';
import { MediaObserver } from '@angular/flex-layout';
import { TypeIndexEnum } from 'src/app/domain/registration/enums/type-index.enum';
import { CustomerCrudIndex } from './crud-index';
import { Router } from '@angular/router';
import { TenantService } from '../../tenants/crud-service';
import { CustomerParcelService } from '../../shared/generate-parcels/crud-service';
import { PermissionService } from 'src/app/shared/permission.service';
import { ContractsService } from '../../contracts/crud-service';
import { take } from 'rxjs';
import { MatTableDataSource } from '@angular/material/table';
import { CustomerContractGenerationService } from '../../contracts/services/customer-contract-generation.service';

@Component({
  selector: 'app-customer-select-index',
  templateUrl: './crud-index-select.component.html',
  styleUrls: ['./crud-index.component.sass'],
  providers: [TenantService],
})
export class CustomerIndexSelectComponent extends CustomerCrudIndex {
  override title: string = 'SELECIONE UM CLIENTE';
  constructor(
    override dialog: MatDialog,
    override service: CustomerService,
    contractsService: ContractsService,
    override toastService: ToastService,
    override mediaObserver: MediaObserver,
    override router: Router,
    public dialogRefSelect: MatDialogRef<CustomerIndexSelectComponent>,
    @Inject(MAT_DIALOG_DATA)
    data: {
      type: TypeIndexEnum;
      select: boolean;
      params: any;
    },
    override tenantService: TenantService,
    override customerParcelService: CustomerParcelService,
    override permissionService: PermissionService,
    override cdr: ChangeDetectorRef,
    customerContractGenerationService: CustomerContractGenerationService,
    private fb: FormBuilder
  ) {
    super(dialog, service, contractsService, toastService, mediaObserver, router, tenantService, customerParcelService, permissionService, cdr, customerContractGenerationService);
    this.dataSelect = data;

    if (data.params?.partnerId) {
      this.setupPartnerFilter(data.params);
    }
  }

  ngOnInit(): void {
    // Carregar lista com filtros aplicados
    this.loadListWithFilters();
  }

  private setupPartnerFilter(params: any): void {
    this.title = 'SELECIONE UM CLIENTE DO PARCEIRO';
    this.params = { ...this.params, ...params };
  }

  private loadListWithFilters(): void {
    if (this.params?.partnerId || this.params?.partnerFilter) {
      this.applyPartnerFilter();
    } else {
      this.loadList();
    }
  }

  private applyPartnerFilter(): void {
    const filterParams: any = {};

    if (this.params.partnerId) {
      filterParams.partner = this.params.partnerId;
    }

    this.submitAdvancedFilter(this.fb.group(filterParams));
  }

  override filter(event: any): void {
    const filterParams: any = { name: event || '' };

    if (this.params?.partnerId) {
      filterParams.partner = this.params.partnerId;
    }

    this.submitAdvancedFilter(this.fb.group(filterParams));
  }

  public updatePartnerFilter(partnerId: string): void {
    if (partnerId) {
      this.params = { ...this.params, partnerId, partnerFilter: true };
      this.title = 'SELECIONE UM CLIENTE DO PARCEIRO';
    } else {
      const { partnerId: _, partnerFilter: __, ...restParams } = this.params || {};
      this.params = restParams;
      this.title = 'SELECIONE UM CLIENTE';
    }

    this.loadListWithFilters();
  }

  onCancel() {
    this.dialogRefSelect.close();
  }

  override submitAdvancedFilter(event: any): void {
    const filterData = event?.value || (typeof event === 'object' ? event : null);

    if (!filterData) return;

    const _filterForm = this.getFilters(filterData);

    this.service
      .findByFilter(_filterForm, this.params)
      .pipe(take(1))
      .subscribe({
        next: (dataWithPagination: any) => {
          const [data, length] = dataWithPagination;
          this.length = length;

          this.dataSource = new MatTableDataSource<any>(
            data.map((item: any) => ({
              ...item,
              document: item.cnpj || item.cpf,
              name: item.companyName || item.name
            }))
          );
        }
      });
  }

  private getFilters(filter: any): any {
    const params: any = {};

    if (filter.name) {
      params.name = filter.name.trim().toUpperCase();
    }

    if (filter.partner) {
      params.partner = filter.partner;
    }

    return params;
  }

  onSelect(data: any) {
    this.dialogRefSelect.close(data?.row);
  }
}
